import { gsap } from "gsap";
import { findAll } from "../utils/dom.js";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import animateFrom from "./animateFrom.js";


export default function animaAoScroll() {

	const start = "top bottom+=100px"

	findAll("[js-anima]")
		.forEach(function (elem) {

			ScrollTrigger.create({
				trigger: elem,
				once: true,
				start: start,
				refreshPriority: 10,
				//markers: true,
				onEnter: function () {
					animateFrom(elem)

				},
				// onEnterBack: function () {
				// 	animateFrom(elem, -1)
				// },
				// onLeave: function () {
				// 	hide(elem)
				// } // assure that the element is hidden when scrolled into view


			});
		});

		function footerAnim(){

        
			let tl = gsap.timeline({
					scrollTrigger: {
							trigger: '#banner-home',
							start: "top+=50px bottom", 
							
						},
					defaults:{  ease: "none"}});
				
						
			tl.fromTo('.logo-wrapper', 	
			{ clipPath: "inset(0  100% 0 0)" },
			{ duration: 1, clipPath: "inset(0 0% 0 0)" })
			.from('.grid-sup-footer .socials li',{
					y: 10,
					opacity: 0,
					stagger:0.2
			}, '<+=0.5')
			.from('.go-top', { y: -80},'<')
			
	}


		// function footerAnim(){

        
		// 	let tl = gsap.timeline({
		// 			scrollTrigger: {
		// 					trigger: '.header-menu',
		// 					start: "top+=50px bottom", 
							
		// 				},
		// 			defaults:{  ease: "none"}});
		// 			tl.set('.header-menu .logo-wrapper', 	
		// 				{ clipPath: "inset( 0 100% 0  0)" },)

			
						
			
		// 	tl.from('#logo ', { x: "-100%"})
		// 	.to('.header-menu .logo-wrapper', 
					
		// 	{duration: 1,  clipPath: "inset( 0 0% 0 0)" }, "+=0.2")
		// 	// { duration: 1, clipPath: "inset(0% 0 0 0)" })
		// 	// .from('.header-menu .socials li',{
		// 	// 		y: 10,
		// 	// 		opacity: 0,
		// 	// 		stagger:0.2
		// 	// }, '<+=0.5')
		// 	// .from('.go-top', { y: -80},'<')
			
		// }

	



	function animateFrom(elem, direction, isMobile) {


			
			direction = direction | 1;
			let delay = 0
			var x = 0,
					y = 0
			//direção
			if (elem.classList.contains("animate-left")) {
					x = -100;
					y = 0;
			} else if (elem.classList.contains("animate-right")) {
					x = 100;
					y = 0;

			} else if (elem.classList.contains("animate-down")) {
					y = 150;

			}
			if(isMobile){
					y = 100
					x = 0
			}


			//delay
			if (elem.dataset.delay) {
					delay = `.${elem.dataset.delay}`

			}
			/* animaçao */
			gsap.fromTo(elem, {
					x: x,
					y: y,
					autoAlpha: 0,
			}, {
					duration: 1,
					x: 0,
					y: 0,
					autoAlpha: 1,
					delay: delay,
					onComplete: () => elem.classList.add("animou"),
					// overwrite: "auto"
			});
	}

	function hide(elem) {
			gsap.set(elem, {
					autoAlpha: 0
			});
	}
	function unhide(elem) {
			gsap.set(elem, {autoAlpha: 1});
		}

	document.addEventListener("DOMContentLoaded", function () {

			var	wideScreen = window.matchMedia("(min-width: 800px)");
			var	narrowScreen = window.matchMedia("(max-width: 799px)");

			gsap.utils.toArray(".js-animate").forEach(function (elem) {
					hide(elem);
			//     if(wideScreen.matches){
			//         hide(elem); // assure that the element is hidden when scrolled into view
			//     }else {
			//         unhide(elem); // assures that the element is visible when scrolled into view below 800px screen-width
			//   }

				ScrollTrigger.matchMedia({	

					"(min-width: 800px)": function() {

							ScrollTrigger.create({
									trigger: elem,
									once: true,
									start: "top+=50px bottom",
									// markers: true,
									onEnter: function () {
											animateFrom(elem)
									},
								
								
									// onEnterBack: function () {
									//     animateFrom(elem, -1)
									// },
									// onLeave: function () {
									//     hide(elem)
									// } // assure that the element is hidden when scrolled into view
							});
					},
					"(max-width: 799px)": function() {
							// The ScrollTriggers created inside these functions are segregated and get
							// reverted/killed when the media query doesn't match anymore. 
			
							ScrollTrigger.saveStyles(".animate-left, .animate-right, .animate-down");
							ScrollTrigger.create({
									trigger: elem,
									once: true,
									start: "top+=50px bottom",
									// markers: true,
									onEnter: function () {
											animateFrom(elem, 1,'is-mobile')
									},
								
								
									// onEnterBack: function () {
									//     animateFrom(elem, -1)
									// },
									// onLeave: function () {
									//     hide(elem)
									// } // assure that the element is hidden when scrolled into view
							});
					 
						},

				})

			});



			
		footerAnim();
			
	});


}